module.exports = __webpack_public_path__ + "img/chr_ts_90_18.e64c7355.png";